<mat-dialog-content>
  <h5 mat-dialog-title>Image Editor</h5>
  <mat-spinner *ngIf="isLoading" diameter="40" class="m-0 m-auto"></mat-spinner>
  <div class="row">
    <div class="col-12 d-flex justify-content-center">
      <button mat-raised-button class="mr-2 primary-button"
              (click)="rotateLeft()">{{ 'DOCUMENTS.img_cropper.rotate_left' | translate }}
      </button>
      <button mat-raised-button class="primary-button"
              (click)="rotateRight()">{{ 'DOCUMENTS.img_cropper.rotate_right' | translate }}
      </button>
    </div>
    <div class="col-6">
      <h4>{{ 'DOCUMENTS.img_cropper.original_image' | translate }}</h4>
      <image-cropper
        [imageChangedEvent]="imageChangedEvent"
        [maintainAspectRatio]="false"
        [containWithinAspectRatio]="false"
        [imageURL]="imageURL"
        [onlyScaleDown]="true"
        [roundCropper]="false"
        [canvasRotation]="canvasRotation"
        [transform]="transform"
        [alignImage]="'left'"
        [style.padding]="0"
        format="png"
        (imageCropped)="imageCropped($event)"
        (imageLoaded)="imageLoaded()"
        (cropperReady)="cropperReady($event)"
        (loadImageFailed)="loadImageFailed($event)">
      </image-cropper>
    </div>
    <div class="col-6">
      <h4>{{ 'DOCUMENTS.img_cropper.cropped_image_preview' | translate }}</h4>
      @if (croppedImage) {
        <img class="img-fluid" [src]="croppedImage" style="max-height: 650px" alt="cropped-preview"/>
      }
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close color="primary" class="ms-2 button-outlined-primary">
    {{ "SHARED.close" | translate }}
  </button>
  <button type="button" mat-raised-button class="primary-button" (click)="submitImage()">
    {{ 'SHARED.submit' | translate }}
  </button>
</mat-dialog-actions>

